import moment from 'moment';

export function goToFirstRoute(menu, router) {
  let route = '/home';

  if (menu && menu.menu && menu.menu.length > 0) {
    const { subLinks } = menu.menu[0];
    if (subLinks && subLinks.length > 0 && subLinks[0].to) {
      route = subLinks[0].to;
    }
  }

  router.push(route);
}

export function createGetParams(params) {
  const getParams = new URLSearchParams();

  Object.keys(params).forEach((key) => {
    if (Array.isArray(params[key])) {
      params[key].forEach((value) => {
        if (value !== null && value !== undefined) {
          getParams.append(key, value);
        }
      });
    } else if (params[key] !== null && params[key] !== undefined) {
      getParams.append(key, params[key]);
    }
  });

  return getParams.toString();
}

export function formatDate(date) {
  return date ? moment(date).format('DD/MM/YYYY') : '';
}
